/**
 * Shared select-field option constants for the profile assessment steps.
 *
 * Extracted from `ProfilePage.tsx` so step components split out of the page
 * (e.g. `DebtsStep`) can reuse the same options without duplicating them.
 */

export const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
] as const

export const MORE_SAME_LESS_OPTIONS = [
  { value: 'more', label: 'More than today' },
  { value: 'same', label: 'About the same' },
  { value: 'less', label: 'Less than today' },
] as const

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
] as const
